import { createContext, useContext } from 'react';

export const AppFormControlContext = createContext<{
  error?: string;
  submitted?: boolean;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  dataTest?: string;
}>({});

export function useAppFormControlContext() {
  return useContext(AppFormControlContext);
}
